<template>
  <v-col cols="12" class="pa-1">
    <v-row justify="center">
      <v-card
        elevation="0"
        class="bg-banner border-radius-1"
        width="99%"
        id="banner"
        :height="this.$vuetify.breakpoint.xs ? 140 : 220"
      >
        <v-row class="ma-0 pa-0" justify="center">
          <v-col cols="auto" class="wrap-profile">
            <v-row align="center" class="flex-nowrap">
              <v-col cols="auto py-0 py-md-3">
                <AvatarIcon v-if="stUserAvatar" :avatar="stUserAvatar" :progress="userData.advancePercent"></AvatarIcon>
                <AvatarIcon v-else></AvatarIcon>
              </v-col>
              <v-col class="text-start py-0 py-md-3 pl-0 pl-md-2 profile-data">
                <div class="profile_name">{{ username }}</div>
                <div class="profile_grade mb-1">{{ user.school.name }} - {{ user.course.name }}</div>
                <StudentCode :code="studentCode" />
              </v-col>
            </v-row>
            <!-- <v-overlay absolute :value="true" opacity="0" width="99%" class="overlay-banner"> -->
              <v-tooltip top max-width="650">
                <template v-slot:activator="{ on: onTooltip }">
                  <v-menu
                    v-model="userMenu"
                    right
                    bottom
                    :close-on-content-click="true"
                    content-class="edit-profile"
                    min-width="180"
                    max-width="200"
                    nudge-top="-15"
                    nudge-right="-100"
                    elevation="0"
                    offset-y
                  >
                    <template v-slot:activator="{ on: onMenu }">
                      <v-btn
                        class="ma-4 edit-btn"
                        data-cy="banner-editMenu-btn"
                        v-on="{ ...onMenu, ...onTooltip }"
                        fab
                        small
                      >
                        <v-img
                          :src="require('@/assets/img/icons/icon-pencil.svg')"
                          :max-height="$vuetify.breakpoint.xs ? '15' : '20'"
                          :max-width="$vuetify.breakpoint.xs ? '15' : '20'"
                        ></v-img>
                      </v-btn>
                    </template>
                    <v-list dense class="mx-2 text-left text-caption">
                      <v-list-item
                        class="px-3"
                        @click="avatarDialog = true"
                        data-cy="banner-editAvatarOption-listItem"
                      >
                        <v-row class="mx-0 px-0" align="center">
                          <v-img src="/img/user/icon-avatar.svg" max-height="25" max-width="25"></v-img>
                          <span class="ml-2 font-weight-bold color-primary">
                            {{ $t('profile.edit_my_avatar') }}
                          </span>
                        </v-row>
                      </v-list-item>
                      <v-list-item class="px-3" @click="categoryDialog = true"
                        data-cy="banner-editCategoryOption-listItem"
                        >
                        <v-row class="mx-0 px-0" align="center">
                          <v-img
                            src="/img/user/icon-categories.svg"
                            max-height="25"
                            max-width="25"
                          ></v-img>
                          <span class="ml-2 font-weight-bold color-primary">
                            {{ $t('profile.my_categories') }}
                          </span>
                        </v-row>
                      </v-list-item>
                      <v-list-item data-cy="banner-editSkinOptionListItem" class="px-3" @click="skinDialog = true">
                        <v-row class="mx-0 px-0" align="center">
                          <v-img src="/img/user/icon-skins.svg" max-height="25" max-width="25"></v-img>
                          <span class="ml-2 font-weight-bold color-primary">
                            {{ $t('profile.my_skins') }}
                          </span>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
                <span>{{ $t('profile.menu_edit_tooltip') }}</span>
              </v-tooltip>
            <!-- </v-overlay> -->
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <EditAvatar
      :dialog="avatarDialog"
      v-on:purchase="setPurchaseAvatar"
      v-on:close="avatarDialog = false"
    />
    <EditCategories :dialog="categoryDialog" v-on:close="categoryDialog = false" />
    <EditSkin
      :dialog="skinDialog"
      v-on:newSkin="newSkin"
      v-on:purchase="setPurchaseSkin"
      v-on:close="skinDialog = false"
    />
    <PurchaseModal
      :dialog="purchaseDialog"
      :buyData="purchaseData"
      v-on:close="closePurchaseDialog"
    />
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import AvatarIcon from './AvatarIcon.vue'
import EditAvatar from './EditAvatar.vue'
import EditCategories from './EditCategories.vue'
import EditSkin from './EditSkin.vue'
import PurchaseModal from './PurchaseModal.vue'
import UserSkinService from '../../services/userSkin'
import StudentCode from '@/components/profile/StudentCode.vue'
import UsersServices from '../../services/users'

export default {
  components: {
    AvatarIcon,
    EditAvatar,
    EditCategories,
    EditSkin,
    PurchaseModal,
    StudentCode,
  },
  data() {
    return {
      avatarDialog: false,
      book: true,
      categoryDialog: false,
      loading: true,
      messagesMenu: false,
      notificationsMenu: false,
      purchaseDialog: false,
      purchaseData: {
        isAvatar: false,
        isSkin: false,
        value: null,
      },
      selectedSkin: null,
      skinDialog: false,
      userMenu: false,
      studentCode: '',
    }
  },
  created() {
    this.getSelectedSkin()
    this.getStudentCode()
  },
  computed: {
    ...mapState({
      user: (state) => state.userData.user,
      userData: (state) => state.userData,
      stUserAvatar: (state) => state.userData.avatarSelected,
    }),
    username() {
      return `${this.user.firstname.split(' ')[0]} ${this.user.lastname.split(' ')[0]}`
    },
  },
  methods: {
    closePurchaseDialog() {
      this.purchaseDialog = false
      if (this.purchaseData.isAvatar) {
        this.avatarDialog = true
      } else {
        this.skinDialog = true
      }
      this.purchaseData.isAvatar = false
      this.purchaseData.isSkin = false
    },
    newSkin(newSkinId) {
      if (this.selectedSkin === null || newSkinId !== this.selectedSkin.id) {
        this.getSelectedSkin()
      }
    },
    setDesktop(skin) {
      if (!skin) {
        return
      }
      const img = skin.resources.find((res) => res.resourceUrl.includes('desktop'))
      const cardBanner = document.getElementById('banner')
      cardBanner.style.backgroundImage = `url("https://assets.beereaders.com/skins/${img.resourceUrl}")`
    },
    setPurchaseAvatar(data) {
      this.purchaseData.isAvatar = true
      this.purchaseData.value = JSON.parse(JSON.stringify(data))
      this.avatarDialog = false
      this.purchaseDialog = true
    },
    setPurchaseSkin(data) {
      this.purchaseData.isSkin = true
      this.purchaseData.value = JSON.parse(JSON.stringify(data))
      this.skinDialog = false
      this.purchaseDialog = true
    },
    getSelectedSkin() {
      UserSkinService.getSelectedByUser(this.user.id)
        .then((response) => {
          this.selectedSkin = response.content
          this.setDesktop(response.content)
        })
        .catch((error) => console.error(error))
    },
    getStudentCode() {
      UsersServices.getStudentCode(this.user.id)
        .then(resp => { this.studentCode = resp.content.codeToAssociate })
        .catch(err => Sentry.captureException(err))
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-banner {
  background: rgb(84, 63, 157);
  background: linear-gradient(
    90deg,
    rgba(84, 63, 157, 1) 0%,
    rgba(145, 121, 215, 1) 50%,
    rgba(84, 63, 157, 1) 100%
  );
  border-radius: 16px;
  background-position: 50% 0%;
  box-shadow: 0px 0px 60px 0px #0000000D;
  position: relative;
  background-size: cover;
}

.overlay-banner {
  align-items: end;
  justify-content: flex-end;
}

.color-primary {
  color: #514773;
}

.color-name {
  color: #4a3216;
}

.v-list-item,
.v-list-item:before {
  border-radius: 10px;
}

.v-list-item:hover {
  background-color: #f3efff;
}

.v-menu__content {
  background-color: #ffff;
  border-radius: 10px;
}

.edit-profile {
  contain: initial;
  overflow: visible;
}

.edit-profile::before {
  position: absolute;
  content: '';
  top: 0;
  right: 45px;
  transform: translateY(-100%);
  width: 15px;
  height: 20px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #fff;
  z-index: 2;
}

.edit-btn:hover {
  box-shadow: 0px 0px 10px 1px rgba(255, 255, 255, 0.267);
  color: rgb(84, 63, 157);
  height: 20px;
  background-color: rgb(84, 63, 157);
  transform: none;
}

.edit-btn:focus {
  box-shadow: 0px 0px 10px 1px rgba(255, 255, 255, 0.267);
  color: rgb(84, 63, 157);
  height: 20px;
  background-color: rgb(84, 63, 157);
  transform: none;
}

.edit-btn:active {
  box-shadow: inset 0px 0px 10px 1px rgba(255, 255, 255, 0.267);
  color: rgb(84, 63, 157);
  height: 20px;
  background-color: rgb(84, 63, 157);
  transform: none;
}
.no-uppercase {
  text-transform: none;
}
.wrap-profile{
  background: #ffffff92;
  border-radius: 16px;
  overflow: hidden;
  padding-left: 44px;
  padding-right: 44px;
  position: relative;
  min-width: 300px;
  z-index: 6;
  .edit-btn{
    background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
    position: absolute;
    height: 40px;
    bottom: 0;
    left: 0;
    z-index: 6;
    @media screen and (max-width: 600px) {
      width: 25px;
      height: 25px;
    }
  }
  &::after{
    content: '';
    filter: blur(20px);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    z-index: 0;
  }
  @media screen and (max-width: 600px) {
    padding-left: 20px;
    padding-right: 20px;
    width: 90%;
  }
}
// .edit-btn {
//   box-shadow: 0px 0px 10px 1px rgba(255, 255, 255, 0.267);
//   height: 40px;
//   width: 40px;

// }
.profile{
  &-data{
    z-index: 1;
  }
  &_name{
    color: #323A46;
    font-size: 19px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: -2%;
  }
  &_grade{
    color: #323A46;
    font-size: 17px;
    font-weight: 400;
  }
}
</style>
